import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  breadcrumbProductUpdates: {
    id: 'Product updates',
    defaultMessage: 'Product updates',
    description: 'Breadcrumb label for the product updates page',
  },
  loadMore: {
    id: 'Load more',
    defaultMessage: 'Load more',
    description: 'Button label to load more feature announcements',
  },
  loading: {
    id: 'Loading...',
    defaultMessage: 'Loading...',
    description: 'Loading state text for the load more button',
  },
  socialHeading: {
    id: "DON'T MISS A THING",
    defaultMessage: "DON'T MISS A THING",
    description: 'Heading for the social/share section',
  },
  socialSubtitle: {
    id: 'From feature drops to product updates—catch it first on our Instagram.',
    defaultMessage: 'From feature drops to product updates—catch it first on our Instagram.',
    description: 'Subtitle for the social/share section',
  },
  socialFollowUs: {
    id: 'Follow us',
    defaultMessage: 'Follow us',
    description: 'Button label for the social/share section CTA',
  },
});
